export default "__VITE_ASSET__DNvMjuBo__"